module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buttonText":"Subscribe now"}}')
  delete Component.options._Ctor
}
